export enum RouteState
{
    shopping = 'shopping',
    checkout = 'checkout',
    myPage = 'myPage',
    other = 'other'
}
